<template>
  <v-dialog v-model="dialog" max-width="500px" @click:outside="closeDialog">
    <v-card>
      <v-toolbar color="primary lighten-1" dark>
        Scan Business Card
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-tabs v-model="activeTab">
          <v-tab>Camera</v-tab>
          <v-tab>Upload</v-tab>
        </v-tabs>
      </v-card-title>
      <v-card-text>
        <v-tabs-items v-model="activeTab">
          <!-- Camera Tab -->
          <v-tab-item>
            <div class="camera-container">
              <video ref="video" :class="{ 'auto-capture': autoCapture }" autoplay v-if="!isProcessing"></video>
              <img v-else :src="capturedImage" class="captured-image" alt="Captured Image" />

              <div class="overlay"></div>
            </div>
            <v-btn 
                @click="captureImage" 
                color="primary"
                class="mt-2 mr-2"
                :disabled="isProcessing"
                >
              Capture
            </v-btn>
            <v-btn 
              @click="switchCamera" 
              color="secondary" 
              class="mt-2 mr-2"
              :disabled="isProcessing"
            >
              Switch Camera
            </v-btn>
            <v-switch 
              v-model="autoCapture"   
              label="Auto Capture" 
              class="mt-2"
              :disabled="isProcessing">
            </v-switch>
          </v-tab-item>

          <!-- Upload Tab -->
          <v-tab-item>
            <v-file-input
              accept="image/*"
              label="Upload Business Card"
              @change="onFileSelected"
              show-size
              prepend-icon="mdi-camera"
              :disabled="isProcessing"
            ></v-file-input>
            <div v-if="cropReady" class="crop-container">
              <img ref="cropperImage" :src="previewImage" alt="Uploaded Image" />
            </div>
            <v-btn v-if="cropReady" @click="cropImage" color="primary" class="mt-2">
              Crop & Process
            </v-btn>
            <v-img v-if="finalCroppedImage" :src="finalCroppedImage" max-height="300" contain class="mt-2"></v-img>
          </v-tab-item>
        </v-tabs-items>
        <!-- Processing Status -->
        <div v-if="isProcessing" class="processing-status">
          <v-progress-circular indeterminate color="primary" class="mr-3"></v-progress-circular>
          <span>{{ processingStatus }}</span>
        </div>
        <v-progress-circular v-if="loading" indeterminate color="primary" class="loading-indicator"></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Cropper from "cropperjs"; // Import Cropper.js library
import dynamic_axios from "../services/dynamic_axios";

export default {
  name: 'CameraDialog',
  emits: ['data-extracted', 'processing-error'], 
  data: () => ({
    dialog: false,
    stream: null,
    activeTab: 0,
    facingMode: "environment",
    autoCapture: false,
    previewImage: null,
    cropReady: false,
    finalCroppedImage: null,
    cropper: null,
    loading: false, // To show loading indicator
    isProcessing: false,
    processingStatus: "",
    company:'triton',
    capturedImage: null,
    sessionAPI:"https://tritonfactsapi.ngrok.io/",
  }),
  methods: {
    async startCamera() {
      if (this.isProcessing) return;
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: this.facingMode, aspectRatio: 1.58 },
        });
        this.$refs.video.srcObject = this.stream;
        if (this.autoCapture) {
          this.startAutoCapture();
        }
      } catch (error) {
        console.error("Error accessing camera:", error);
        this.$emit("camera-error", error);
      }
    },
    async captureImage() {
      if (!this.stream || this.isProcessing) return;
      // if (!this.stream) {
      //   console.error("Camera not started");
      //   return;
      // }

      const video = this.$refs.video;
      const aspectRatio = 1.58; // Business card aspect ratio
      
      // Calculate dimensions to maintain aspect ratio
      let captureWidth = video.videoWidth;
      let captureHeight = captureWidth / aspectRatio;
      
      if (captureHeight > video.videoHeight) {
        captureHeight = video.videoHeight;
        captureWidth = captureHeight * aspectRatio;
      }

      const canvas = document.createElement('canvas');
      canvas.width = captureWidth;
      canvas.height = captureHeight;
      
      // Calculate centering
      const sx = (video.videoWidth - captureWidth) / 2;
      const sy = (video.videoHeight - captureHeight) / 2;
      
      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        video,
        sx, sy, captureWidth, captureHeight,  // Source rectangle
        0, 0, captureWidth, captureHeight     // Destination rectangle
      );

      this.capturedImage = canvas.toDataURL('image/jpeg');
      this.isProcessing = true;
      this.processingStatus = "Processing image...";
      this.stopCamera();

      try {
        await this.sendImageToServer(this.capturedImage);
      } catch (error) {
        this.isProcessing = false;
        this.processingStatus = "";
        this.startCamera();
        throw error;
      }

      // const canvas = document.createElement("canvas");
      // canvas.width = this.$refs.video.videoWidth;
      // canvas.height = this.$refs.video.videoHeight;
      // const ctx = canvas.getContext("2d");
      // ctx.drawImage(this.$refs.video, 0, 0);
      
      // this.capturedImage = canvas.toDataURL("image/jpeg");
      // this.isProcessing = true;
      // this.processingStatus = "Processing image...";
      // this.stopCamera(); // Stop camera feed

      // try {
      //   await this.sendImageToServer(this.capturedImage);
      // } catch (error) {
      //   this.isProcessing = false;
      //   this.processingStatus = "";
      //   this.startCamera(); // Restart camera on error
      //   throw error;
      // }
      // this.loading = true; // Show loading indicator
      // const imageDataUrl = canvas.toDataURL("image/jpeg");

      // // Send the captured image to the server
      // await this.sendImageToServer(imageDataUrl);
      // this.loading = false; // Hide loading indicator
    },
    async onFileSelected(file) {
      if (!file) {
        this.previewImage = null;
        return;
      }
      this.previewImage = URL.createObjectURL(file);
      this.cropReady = true;

      // Initialize Cropper.js
      this.$nextTick(() => {
        this.initializeCropper();
        // if (this.cropper) this.cropper.destroy();
        // const imageElement = this.$refs.cropperImage;
        // this.cropper = new Cropper(imageElement, {
        //   aspectRatio: 1.58, // Aspect ratio for business cards
        //   viewMode: 1,
        // });
      });
    },
    initializeCropper() {
      if (this.cropper) this.cropper.destroy();
      const imageElement = this.$refs.cropperImage;
      this.cropper = new Cropper(imageElement, {
        aspectRatio: 1.58, // Business card aspect ratio
        viewMode: 2, // Restrict view to container
        dragMode: 'move',
        autoCropArea: 1,
        responsive: true,
        restore: false,
        center: true,
        highlight: false,
        cropBoxMovable: true,
        cropBoxResizable: true,
        guides: true,
        minContainerWidth: 300,
        minContainerHeight: 200,
      });
    },
    async cropImage() {
      if (this.cropper) {
        const croppedCanvas = this.cropper.getCroppedCanvas();
        const croppedImage = croppedCanvas.toDataURL("image/jpeg");
        this.finalCroppedImage = croppedImage;

        this.loading = true; // Show loading indicator
        await this.sendImageToServer(croppedImage);
        this.loading = false; // Hide loading indicator

        this.cropReady = false; // Reset crop state
      }
    },
    async sendImageToServer(imageData) {
      try {
        // Convert base64 to blob
        const base64Response = await fetch(imageData);
        const blob = await base64Response.blob();
        
        // Create FormData and append image
        const formData = new FormData();
        formData.append('image', blob, 'business-card.jpg');

        const response = await dynamic_axios.post("/scan-card", 
          formData,
          {
            headers: {},
            apiName: this.company
          }
        );

        if (response.data.data) {
          alert(JSON.stringify(response.data.data, null, 2));
          this.processingStatus = "Processing complete!";
          const extractedData = this.mapExtractedData(response.data.data);
          this.emitFinalData(extractedData);
        } else {
          throw new Error("No data extracted");
        }
      } catch (error) {
        console.error("Server processing error:", error);
        this.$emit("processing-error", "Failed to process the image. Please try again.");
        throw error;
      } finally {
        this.isProcessing = false;
        this.processingStatus = "";
      }
    },
    // async sendImageToServer(imageData) {
    //   try {
    //     const response = await dynamic_axios.post("/scan-card", 
    //     { image_data: imageData , apiName:this.company });
    //     if (response.data.data) {
    //       const extractedData = this.mapExtractedData(response.data.data);
    //       this.emitFinalData(extractedData);
    //     } else {
    //       this.$emit("processing-error", "No data extracted. Please try again.");
    //     }
    //   } catch (error) {
    //     console.error("Server processing error:", error);
    //     this.$emit("processing-error", "Failed to process the image. Please try again.");
    //   }
    // },
    // mapExtractedData(data) {
    //   return {
    //     SAL_CONTACT_NAME: data.name || "",
    //     SAL_CUSTOMER_NAME: data.company || "",
    //     SAL_BILL_EMAIL: data.email || "",
    //     SAL_BILL_TEL1: data.phone || "",
    //     SAL_BILL_ADDRESS: data.address || "",
    //     SAL_BILL_WEBSITE: data.website || "",
    //   };
    // },
    mapExtractedData(data) {
      console.log("Raw API response:", data); // Debug log
      // Safely map fields, checking for optional or missing values
      const mappedData = {
        SAL_CONTACT_NAME: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
        SAL_CUSTOMER_NAME: data.jobs?.[0]?.company || '',
        SAL_BILL_EMAIL: data.emails?.[0]?.address || '',
        SAL_BILL_TEL1: data.phones?.[0]?.number || '',
        SAL_BILL_ADDRESS: data.addresses?.[0]?.fullAddress || '',
        SAL_BILL_WEBSITE: data.websites?.[0]?.url || '',
        SAL_REFERENCE1: JSON.stringify(data, null, 2), // Save the entire object as a fallback
      };
      console.log("Mapped data:", mappedData); // Debug log
      return mappedData;
    },
    emitFinalData(data) {
      console.log("Emitting data to parent:", data); // Debug log
      this.$emit('data-extracted', data);
      // Add small delay before closing to ensure emission completes
      setTimeout(() => {
        this.closeDialog();
      }, 100);
    },
    switchCamera() {
      this.facingMode = this.facingMode === "user" ? "environment" : "user";
      this.stopCamera();
      this.startCamera();
    },
    closeDialog() {
      this.dialog = false;
      this.stopCamera();
      if (this.cropper) this.cropper.destroy();
      this.cropReady = false;
      this.previewImage = null;
      this.finalCroppedImage = null;
    },
    stopCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    },
  },
  watch: {
    dialog(newVal) {
      if (newVal && this.activeTab === 0) {
        this.startCamera();
      } else {
        this.stopCamera();
      }
    },
    activeTab(newVal) {
      if (newVal === 0) {
        this.startCamera();
      } else {
        this.stopCamera();
      }
    },
  },
  beforeDestroy() {
    this.stopCamera();
    if (this.cropper) this.cropper.destroy();
  },
};
</script>

<style scoped>
.camera-container {
  position: relative;
  width: 100%;
  padding-top: 63.29%; /* Maintains 1.58:1 aspect ratio (1/1.58 ≈ 0.6329) */
  overflow: hidden;
  background-color: #f5f5f5;
  margin-bottom: 16px;
}

.camera-container video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.captured-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.captured-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  margin: auto;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #fff;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

.crop-container {
  position: relative;
  max-width: 100%;
  height: 300px; /* Fixed height for crop container */
  overflow: hidden;
  margin: 10px 0;
  background-color: #f5f5f5;
}

.crop-container img {
  max-width: 100%;
  max-height: 100%;
}

.preview-image {
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background-color: #f5f5f5;
}

.processing-status {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

/* Cropper.js custom styles */
.cropper-view-box {
  outline: 2px solid #fff;
  outline-color: rgba(255, 255, 255, 0.75);
}

.cropper-face {
  background-color: inherit !important;
}

.cropper-dashed {
  border-color: rgba(255, 255, 255, 0.5);
}

.auto-capture {
  border: 2px solid #4CAF50;
}
</style>